import { FC } from 'react'
import { Typography, ConfigProvider, theme, Image, Space } from 'antd'
import { Link } from 'react-router-dom'

interface BrandLogoProps {
  collapsed?: boolean
}

const { Title } = Typography

const BrandLogo: FC<BrandLogoProps> = ({ collapsed = false }) => {
  const { token } = theme.useToken()
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: token.colorPrimary,
          fontFamily: 'Noto Sans',
          fontSize: 16,
        },
      }}
    >
      <Link to="/">
        {collapsed ? (
          <Image
            src="https://storage.cloud.google.com/shopap-public-asset/shopap-canva-transparent.png"
            height={40}
            width={40}
            preview={false}
          />
        ) : (
          <Space size={0} direction="horizontal" align="center">
            <Image
              src="https://storage.cloud.google.com/shopap-public-asset/shopap-canva-transparent.png"
              height={40}
              width={40}
              preview={false}
            />
            <Title
              level={2}
              style={{ color: token.colorPrimary, fontFamily: 'Noto Sans', padding: '0px 0px', margin: 0 }}
            >
              Shopap
            </Title>
          </Space>
        )}
      </Link>
    </ConfigProvider>
  )
}

export default BrandLogo
